export default "<p>new-pending-list works!</p>\n"